import React from 'react';
import { Card, CardContent, Box, Typography } from '@/ui';
import type { SummaryCard } from './types';

interface SummaryCardProps {
  card: SummaryCard;
  onClick?: () => void;
  isActive?: boolean;
}

const SummaryCardComponent: React.FC<SummaryCardProps> = ({ card, onClick, isActive = false }) => (
  <Card
    onClick={onClick}
    sx={{
      background: card.backgroundGradient || card.backgroundColor,
      backgroundColor: card.backgroundColor,
      border: isActive ? `2px solid ${card.color}` : '1px solid rgba(203, 213, 225, 0.6)',
      borderRadius: '12px',
      boxShadow: '0px 1px 2px 0px #0000000D',
      height: '100%',
      minHeight: '179px',
      width: '100%',
      position: 'relative',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'transform 0.2s, box-shadow 0.2s, border 0.2s',
      transform: isActive ? 'translateY(-4px)' : 'translateY(0)',
      boxSizing: 'border-box',
      '&:hover': onClick ? {
        transform: 'translateY(-4px)',
        border: `2px solid ${card.color}`,
        boxShadow: '0px 1px 2px 0px #0000000D',
      } : {}
    }}
  >
    <CardContent sx={{ p: '21px', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'flex-start', 
        justifyContent: 'space-between', 
        width: '100%',
        mb: 1 
      }}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
          {card.icon}
        </Box>
        {card.frequency && (
          <Typography
            variant="body2"
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              color: '#64748B',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              px: 1,
              py: 0.5,
              borderRadius: '6px',
              flexShrink: 0,
              ml: 1
            }}
          >
            {card.frequency}
          </Typography>
        )}
      </Box>
      <Typography
        variant="body2"
        sx={{
          fontSize: '13px',
          fontWeight: 600,
          color: '#64748B',
          mb: 1.5
        }}
      >
        {card.label}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: '20px', md: '24px' },
          fontWeight: 700,
          color: '#1E293B',
          mb: 'auto'
        }}
      >
        {card.amount}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          fontSize: '11px',
          color: card.color,
          fontWeight: 500,
          mt: 1
        }}
      >
        {card.status}
      </Typography>
    </CardContent>
  </Card>
);

export default SummaryCardComponent;


